import Swal from 'sweetalert2';
import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-plugin-navbar',
  templateUrl: './plugin-navbar.component.html',
  styleUrls: ['./plugin-navbar.component.css']
}) 
export class PluginNavbarComponent implements OnInit { 
  
  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute,private route: Router,public encDec: EncryptDecryptService, public translate: TranslateService ) { }
  shownav:boolean=false;
  backendUrl = environment.serviceURL;
  allLinks:any=[];
  tertiary_menu:any={};
  has_tertiary_menu:any=false;
  tertiaryList:any=[];
  check_total_current_menu:any=0; 
  current_menu:any={};
  plugin_menu_dtl:any="";

  currentRouter:any;
 
  @Output() childEvent = new EventEmitter();

  @Input() datacollection:any;
 

  currentLink:any = this.route.url.replace('/',"");
  language:any = '';
  CurrentRouteFn:any = ():any => {
    let route_url:any = this.route.url.replace('/',"");
    route_url = route_url.split("?");
    if(route_url.length > 0){
      return route_url[0];
    }
    return route_url;
  }

  ngOnInit(): void { 
    this.plugin_menu_dtl = window.sessionStorage.getItem(btoa(this.CurrentRouteFn()));
    this.plugin_menu_dtl =JSON.parse(this.plugin_menu_dtl);
    this.language = sessionStorage.getItem('locale');//dynamic
    this.currentRouter = this.route.url;
    if(this.datacollection.data.status){
      this.allLinks = this.datacollection.data.secondary_menu_list
      this.has_tertiary_menu = this.datacollection.data.has_tertiary_menu;
      this.tertiaryList = this.datacollection.data.tertiaryList;
      this.check_total_current_menu = this.datacollection.data.check_total_current_menu;
      this.current_menu = this.datacollection.data.current_menu;
    }
     
  } 


  goToContentPage(menu:any)
  {
      this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.route.navigate(['./view'+'/'+menu.VCHMENUALIAS]));
   } 
 
 goToExtLink(url:any,primaryHeader:any)
 {
    Swal.fire({
     title: 'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
     text: 'Are you sure?',
     showCancelButton: true,
     confirmButtonText: 'Yes',
     cancelButtonText: 'No'
   }).then((result) => {
     if (result.value) {
      window.open(url, '_blank');
   }
 });
 }

 goToPluginPage(link:any,menudtl:any)
   {
    sessionStorage.removeItem(btoa(menudtl.selectPlugin));
    sessionStorage.setItem(btoa(menudtl.selectPlugin),JSON.stringify(menudtl));
    this.route.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    this.route.navigate([link]));
   }

   htmldecode(str: any){
    return this.encDec.decodeHtml(str);
  }



  gettertiary:any= (secondaryid:any):any =>{
    let list:any = [];
    let data =this.tertiaryList;
    for (let i = 0; i < data.length; i++) {
      if(data[i].VCHSECONDARY_ID==secondaryid){
        list.push(data[i]);
      } 
    }
    return list;
  }




  checkCurrentSecondary:any = (secondaryid:any):any =>{
    return this.current_menu.VCHSECONDARY_ID == secondaryid ? true:false;
    // let menuAlias:any = this.routerparam.snapshot.paramMap.get('aliasName');
    // let list:any = [];
    // let data =this.tertiaryList;
    // for (let i = 0; i < data.length; i++) {
    //   if(data[i].VCHSECONDARY_ID==secondaryid){
    //     list.push(data[i]);
    //   }
    // }
    // // console.log(list);
    // for (let x = 0; x < list.length; x++) {
    //    if(list[x].VCHMENUALIAS == this.menuAlias){
    //     return true
    //    }
    // }
    // return false
  }






}
